import { CustomReportColumn } from '@app/modules/reporting/interfaces/custom-report-column.interface';
import { Model } from '../core/base.model';
import { Employee } from '../employee/employee.model';
import { CustomReportFilter } from './custom-report-filter.model';

export class CustomReportQuery extends Model {
    protected static _resource = 'reports/custom';

    protected static _version = 'v2';

    protected static _type = 'customReports';
    protected static _serializeAttributes = ['report_type', 'name', 'columns'];

    get customReportQueryId(): number {
        return this._attributes['id'];
    }

    set reportType(val: string) {
        this._attributes['report_type'] = val;
    }

    get name(): string {
        return this._attributes['name'];
    }

    set name(val: string) {
        this._attributes['name'] = val;
    }

    get columns(): CustomReportColumn[] {
        return this._attributes['columns'];
    }

    set columns(val: CustomReportColumn[]) {
        this._attributes['columns'] = val;
    }

    get filters(): CustomReportFilter[] {
        return this.hasMany(CustomReportFilter, 'filters');
    }

    get lastUpdatedBy(): Employee {
        return this.hasOne(Employee, 'lastUpdatedBy');
    }

    getColumns(): Promise<any> {
        const url =
            CustomReportQuery._version +
            '/' +
            CustomReportQuery._resource +
            '/' +
            'columns?custom_report_type=employee';

        return Model.performGet(url);
    }
}
